
import { CheckBoxButton } from "@goodgamestudios/asset-globals";

import { BasicModel } from "@goodgamestudios/core";
import { BasicSmartfoxConstants } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2OptionDialog extends Poker2Dialog {
    private static C2S_CHANGE_PASSWORD: string = "lcp";

    public static NAME: string = "Poker2OptionDialog";

    protected applyProperties(): void {
        super.applyProperties();

        if (!this.env.loginIsKeyBased) {
            this.optionDialog.gotoAndStop(1);
            this.optionDialog.btn_changepass.label = Poker2Model.languageData.getTextById("generic_change_password_title");
            this.optionDialog.txt_oldpass.displayAsPassword = true;
            this.optionDialog.txt_newpass.displayAsPassword = true;
            this.optionDialog.txt_oldpass.text = "";
            this.optionDialog.txt_newpass.text = "";
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_copy_0, Poker2Model.languageData.getTextById("generic_change_password_copy_oldpass"));
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_copy_1, Poker2Model.languageData.getTextById("generic_change_password_copy_newpass"));
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_head, Poker2Model.languageData.getTextById("generic_change_password_title"));
        } else {
            this.optionDialog.gotoAndStop(2);
        }
        // fix elements since dialog disp is a movieclip, things are a bit messed up
        this.optionDialog.changeTextFieldCacheScale(Poker2LayoutManager.GAME_SCALE_FACTOR);
        this.optionDialog.btn_close.gotoAndStop(1);
        this.optionDialog.addChildAt(this.bg, 0);

        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_title, Poker2Model.languageData.getTextById("menu_btn_properties"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_tooltips, Poker2Model.languageData.getTextById("dialog_options_showtooltip"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.optionDialog.txt_friends_requests, Poker2Model.languageData.getTextById("dialog_options_ignorebuddyrequest"));
        this.optionDialog.txt_guestchat.text = Poker2Model.languageData.getTextById("dialog_options_showspecs");

    }

    public show(): void {
        super.show();
        if (Poker2Model.userData.gamePropertiesVO.showTooltip == 1)
            this.optionDialog.checkbox_0.selected();
        else
            this.optionDialog.checkbox_0.deselected();

        if (Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest == 1)
            this.optionDialog.checkbox_1.selected();
        else
            this.optionDialog.checkbox_1.deselected();

        if (Poker2Model.userData.gamePropertiesVO.isSpec == 1)
            this.optionDialog.checkbox_2.selected();
        else
            this.optionDialog.checkbox_2.deselected();

        this.controller.addEventListener("changePasswordComplete", this.bindFunction(this.onChangePasswordComplete));
        this.controller.addEventListener("changePasswordFaild", this.bindFunction(this.onChangePasswordComplete));
    }

    public hide(): void {
        this.controller.removeEventListener("changePasswordComplete", this.bindFunction(this.onChangePasswordComplete));
        this.controller.removeEventListener("changePasswordFaild", this.bindFunction(this.onChangePasswordComplete));
        super.hide();
    }

    private onChangePasswordFaild(event: Poker2UserEvent): void {
        this.hide();
    }
    private onChangePasswordComplete(event: Poker2UserEvent): void {
        Poker2Model.userData.loginPwd = TextValide.trimPassword(this.optionDialog.txt_newpass.text);
        Poker2Model.localData.saveLoginData(Poker2Model.userData.userName, Poker2Model.userData.loginPwd, true);	// hgs HS892
        this.hide();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.optionDialog.btn_close:
                this.hide();
                break;
            case this.optionDialog.btn_changepass:
                if (!TextValide.isSmartFoxValide(TextValide.trimPassword(this.optionDialog.txt_newpass.text)) ||
                    !TextValide.isSmartFoxValide(TextValide.trimPassword(this.optionDialog.txt_oldpass.text)))
                    this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_watchout"), Poker2Model.languageData.getTextById("generic_change_password_faild_specialcharacters")));
                else if (TextValide.trimPassword(this.optionDialog.txt_newpass.text).length > 2 && TextValide.trimPassword(this.optionDialog.txt_oldpass.text) == Poker2Model.userData.loginPwd) {
                    var paramObject: any = { oldPW: TextValide.trimPassword(this.optionDialog.txt_oldpass.text), newPW: TextValide.trimPassword(this.optionDialog.txt_newpass.text) };
                    BasicModel.smartfoxClient.sendMessage(Poker2OptionDialog.C2S_CHANGE_PASSWORD, [JSON.stringify(paramObject)]);
                }
                else
                    this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_change_password_title"),
                        Poker2Model.languageData.getTextById("generic_change_password_faild_copy")));
                break;
            case this.optionDialog.txt_oldpass:
                this.optionDialog.txt_oldpass.text = "";
                break;
            case this.optionDialog.txt_newpass:
                this.optionDialog.txt_newpass.text = "";
                break;
            case this.optionDialog.txt_newpass_2:
                this.optionDialog.txt_newpass_2.text = "";
                break;
            case this.optionDialog.checkbox_0:
            case this.optionDialog.checkbox_1:
            case this.optionDialog.checkbox_2:
                this.changeOption(event.target as CheckBoxButton);
                break;
        }
    }

    private changeOption(checkBox: CheckBoxButton): void {
        switch (checkBox) {
            case this.optionDialog.checkbox_0:
                Poker2Model.userData.gamePropertiesVO.showTooltip = (this.optionDialog.checkbox_0.isSelected) ? 0 : 1;
                break;
            case this.optionDialog.checkbox_1:
                Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest = (this.optionDialog.checkbox_1.isSelected) ? 0 : 1;
                break;
            case this.optionDialog.checkbox_2:
                Poker2Model.userData.gamePropertiesVO.isSpec = (this.optionDialog.checkbox_2.isSelected) ? 0 : 1;
                break;
        }
        var paramObject: any = {
            showTT: Poker2Model.userData.gamePropertiesVO.showTooltip,
            ignoreBuddy: Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest,
            playSound: Poker2Model.userData.gamePropertiesVO.playSound,
            isSpecs: Poker2Model.userData.gamePropertiesVO.isSpec
        };
        BasicModel.smartfoxClient.sendMessage("gpc", [JSON.stringify(paramObject)]);
        checkBox.toggleSelected();
    }

    constructor(disp: Container) {
        super(disp);
    }

    protected get optionDialog(): Library.PokerInterface.PokerOption {
        return this.disp as Library.PokerInterface.PokerOption;
    }
}
import { Poker2StandardOkDialog } from "./Poker2StandardOkDialog";
import { Poker2WarningDialog } from "./Poker2WarningDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

